<template>
  <div>
    <div class="jazeModalContainer jazeModalContainer--blackout jazeModalContainer--centered" dialog-layout="speedTestLayout" v-show="allowIpModalShow" style="display:flex">
      <div class="pos-relative" dialog-window>
        <div dialog-content>
          <div class="jazeModal jazeModal--small unifiSpeedTestModal unifiSpeedTestModal--inProgress">
            <form class="jazeForm jazeModal jazeModal--small unifiAddUser">
              <div class="jazeModal__header pb-0">
                <div class="jazeHeader jazeHeader--centered">
                  <div class="jazeHeader__title">Delete Admin IP</div>
                  <svg viewBox="0 0 14 14" class="jazeIcon jazeIcon--actionable" @click="onclose">
                    <g transform="translate(8.5 7.2071) rotate(45) translate(-9 -9)">
                      <path d="m9.0294 8.7071h8v1h-8v8h-1v-8h-8v-1h8v-8h1v8z" />
                    </g>
                  </svg>
                </div>
              </div>
              <form ref="connectForm" :class="formClass">
                <div class="jazeModal__main">
                  <div class="jazeModalContent pb-1">
                    <div class="container container--horizontal-cozy container--vertical-comfy">
                      <div>Are you sure you want to delete the admin IP ?</div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="jazeModal__footer">
                <div class="jazeButtonGroup jazeButtonGroup--cozy">
                  <button class="jazeButton jazeButton--secondary" @click="onclose">Cancel</button>
                  <button class="jazeButton jazeButton--primary" type="submit" @click="extendSubmit">Delete</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <SuccessToaster :successMessage='successMessage' :sucesstoasterShow='successtoaster' v-if='successtoaster'></SuccessToaster>
    <ErrorToaster :errorMessage='errorMessage' :errortoasterShow='errortoaster' v-if='errortoaster'></ErrorToaster>
  </div>
</template>
<script setup>
import Nprogress from "nprogress";
import axios from "@/api/index";
import SuccessToaster from "@/components/Toaster/SuccessToaster.vue";
import ErrorToaster from "@/components/Toaster/ErrorToaster.vue";
import { useaccountsettingStore } from '@/store/accountsettingstore';
import { usesettingsStore } from '@/store/settingsstore'
import {ref,toRef,defineProps,defineEmits,watch,onMounted} from 'vue';

  const emit = defineEmits(['extend-clicked-deleteip-detail']);
  const props = defineProps(["deleteIPId", "fromwhere"]);

  const accountsettingStore = useaccountsettingStore();
  const settingStore = usesettingsStore();
  const deleteIPId=toRef(props,'deleteIPId');
  const fromwhere=toRef(props,'fromwhere');

  const formClass = ref('appForm appForm--cozy is-validation-hidden');
  const allowIpModalShow = ref(true);
  const successtoaster = ref(false);
  const successMessage = ref('');
  const errorMessage = ref('');
  const errortoaster = ref(false);
  const netMask = ref(null);
  const IPAddress = ref(null);

  const onclose = ()=> {
    allowIpModalShow.value = false;
    emit("extend-clicked-deleteip-detail", allowIpModalShow.value);
  };

  const extendSubmit = (e)=> {
    e.preventDefault();
    const postData = {};
    postData.adminIpId = deleteIPId.value;
    if(fromwhere.value != undefined && fromwhere.value == "api") {
      settingStore.deleteApiIPAddress(postData).then(  
        (response) => {
          allowIpModalShow.value = false;
          successtoaster.value = true;
          successMessage.value = response.genericBody;
          setTimeout(
            function () {
              successtoaster.value = false;
              emit("extend-clicked-deleteip-detail", false);
            }.bind(this),
            1500
          );
        },
        (error) => {
          errortoaster.value = true;
          allowIpModalShow.value = false;
          errorMessage.value = error;
          setTimeout(
            function () {
              errortoaster.value = false;
            }.bind(this),
            1500
          );
          console.log(error);
        }
      );
    } else {
      // $store.dispatch("deleteAdminIPAddress", postData).then(
      accountsettingStore.deleteAdminIPAddress(postData).then(  
        (response) => {
          allowIpModalShow.value = false;
          successtoaster.value = true;
          successMessage.value = response.genericBody;
          setTimeout(
            function () {
              successtoaster.value = false;
              emit("extend-clicked-deleteip-detail", false);
            }.bind(this),
            1500
          );
        },
        (error) => {
          errortoaster.value = true;
          allowIpModalShow.value = false;
          errorMessage.value = error;
          setTimeout(
            function () {
              errortoaster.value = false;
            }.bind(this),
            1500
          );
          console.log(error);
        }
      );
    }
  };

</script>